import { RankingsComponent } from './rankings/rankings.component'
import { RankingComponent } from './ranking/ranking.component'
import { RankingsRoutingModule } from './rankings-routing.module'
import { RankingsService } from './rankings.service'
import { SharedModule } from '../shared/shared.module'
import { PaywallModule } from '../shared/paywall/paywall.module'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule } from '@angular/forms'
import { RankingResolver } from './ranking/ranking.resolver'
import { Router, RouterModule } from '@angular/router'
import { SlimHeaderModule } from '../libs/slim-header/slim-header.module'
import { PrimaryRelatedContentModule } from '../libs/primary-related-content/primary-related-content.module'
import { CustomLinkModule } from '../libs/custom-link/custom-link.directive.module'
import { AuthorDateModule } from '../shared/author-avatar/author-date/author-date.module'
import { RankingsAnalyticsService } from './rankings-analytics.service'
import { OldTabsModule } from '../libs/_deprecated/tabs/old-tabs.module'

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    CustomLinkModule,
    RankingsRoutingModule,
    PaywallModule,
    ReactiveFormsModule,
    OldTabsModule,
    SlimHeaderModule,
    PrimaryRelatedContentModule,
    AuthorDateModule,
    RouterModule
  ],
  exports: [RankingComponent],
  declarations: [RankingsComponent, RankingComponent],
  providers: [
    RankingsService,
    RankingsAnalyticsService,
    {
      provide: RankingResolver,
      useClass: RankingResolver,
      deps: [RankingsService, Router]
    }
  ]
})
export class RankingsModule {}
